<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getUrlParam } from "@/utils/param";
export default {
  name: "App",
  mounted() {
    let code = getUrlParam("code");
    if(!code){
      console.log(1)
      this.authorVerify(window.location.href);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue